import MakeReadyItemCell from "../makeReadyItemCell";
import MakeReadyCheckboxCell from '../makeReadyCheckboxCell';
import MakeReadyTextInputCell from '../makeReadyTextInputCell';
import MakeReadyTextCell from "../makeReadyTextCell";
import MakeReadyDateInputCell from "../makeReadyDateInputCell";
import MakeReadyNACell from "../makeReadyNACell";
import MakeReadyFloatInputCell from "../makeReadyFloatInputCell";
import MakeReadyTagsInputCell from "../makeReadyTagsInputCell";
import MakeReadyDisabledCell from "../makeReadyDisabledCell";
import MakeReadyInspectionCell from "../makeReadyInspectionCell";

export default {
  MakeReadyItemCell,
  MakeReadyCheckboxCell,
  MakeReadyTextInputCell,
  MakeReadyTextCell,
  MakeReadyDateInputCell,
  MakeReadyNACell,
  MakeReadyFloatInputCell,
  MakeReadyTagsInputCell,
  MakeReadyDisabledCell,
  MakeReadyInspectionCell
}
